import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M28.283 18.551c.258.075.628.952 1.08 1.139.226.41-.065.784-.161.859-.097.074-.532.28-.597-.019s-.193-.243-.193-.243-2.064 2.334-4.45 2.24c-2.466.019-4.497-2.24-4.497-2.24l-.177.224s-.194.243-.29.224c-.097-.018-.517-.336-.549-.653s.258-.523.258-.523.71-.634.79-.97c.161-.187.468.13.468.13s1.82 2.334 3.95 2.334c2.128 0 3.827-2.04 3.827-2.04s.283-.536.54-.462",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "m19.7 10.05 8.633-.05v7.688c.017.999-1.68 2.014-4.333 3.312-2.738-1.398-4.317-2.247-4.334-3.328z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M26.667 12c.368 0 .666-.15.666-.333s-.298-.334-.666-.334-.667.15-.667.334.299.333.667.333m-5.334 0c.368 0 .667-.15.667-.333s-.299-.334-.667-.334-.666.15-.666.334.298.333.666.333m0 1.333c.368 0 .667-.149.667-.333s-.299-.333-.667-.333-.666.149-.666.333.298.333.666.333m0 1.334c.368 0 .667-.15.667-.334S21.7 14 21.333 14s-.666.15-.666.333.298.334.666.334M22.667 16c.368 0 .666-.15.666-.333s-.298-.334-.666-.334-.667.15-.667.334.299.333.667.333m-1.334 1.333c.368 0 .667-.149.667-.333s-.299-.333-.667-.333-.666.149-.666.333.298.333.666.333m0 1.334c.368 0 .667-.15.667-.334S21.7 18 21.333 18s-.666.15-.666.333.298.334.666.334m5.334-5.334c.368 0 .666-.149.666-.333s-.298-.333-.666-.333S26 12.816 26 13s.299.333.667.333m0 1.334c.368 0 .666-.15.666-.334S27.035 14 26.667 14s-.667.15-.667.333.299.334.667.334m0 1.333c.368 0 .666-.15.666-.333s-.298-.334-.666-.334-.667.15-.667.334.299.333.667.333m0 1.333c.368 0 .666-.149.666-.333s-.298-.333-.666-.333S26 16.816 26 17s.299.333.667.333m0 1.334c.368 0 .666-.15.666-.334S27.035 18 26.667 18s-.667.15-.667.333.299.334.667.334",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFC6B5",
      fillRule: "evenodd",
      d: "M23.962 12.47s.047-.2 0-.19-.15-.035-.21-.07c-.061-.034.023-.161 0-.166-.024-.005 0-.108 0-.108s-.057-.01-.061-.04c-.005-.029.032-.039.037-.034s.084-.098.08-.147l-.015-.142.033-.187.515.074s.028.643.01.785c-.02.142.05.191.05.191l.099.13-.88 1.401s-.257.29-.327.349-.384.3-.384.3-.164.117-.112.151c.051.035.042.216.042.216s-.15.422-.197.403c-.182-.04-.135-.388-.14-.467-.005-.078.178-.29.225-.353.046-.064.173-.304.257-.422s.36-.447.36-.447.033-.294.094-.588c-.01-.305.224-.418.224-.418z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M24.42 12.456c.175-.004.45.396.44.51-.008.113-.256.765-.264.836-.01.07 0 .947 0 .947l.265 2.628.34 1.753s-.512.281-.933.315c-.425.034-.977-.092-.977-.092l-.088-1.833.39-3.833s-.182-.095-.186-.239c-.017-.23.172-.358.194-.434s.024-.445.345-.542c.039.363.401.063.474-.016",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M23.788 11.543s.105.013.163-.018c.057-.032.124-.046.172.018.048.063.081.058.081.058s-.071.168 0 .186c.072.018.106.018.11.04s-.062.073-.043.095.053.05.058.068-.043.095-.029.113.057.09.086.09.01.114.096.087.081-.1.081-.1.091-.013.115-.09.081-.095.081-.095.115-.059-.038-.15c0-.633-.44-.565-.44-.565s-.053-.113-.139-.1c-.086.014-.09.11-.153.1-.062-.009-.076-.05-.081-.045a.5.5 0 0 0-.058.118c0 .022-.167-.032-.153.086s.096.113.091.104",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFC6B5",
      fillRule: "evenodd",
      d: "M25.114 14.336c-.027.074-.307.428-.34.518s-.23.434-.23.434-.05.338-.072.354.057.099.05.127c-.011.031-.16.18-.225.164-.066-.016-.17-.09-.176-.159s.006-.296.055-.354c.05-.058.307-.645.324-.682.016-.037.236-.497.241-.576.006-.08-.082-.264-.16-.331-.19-.465-.141-.794.269-.897.005 0 .176.536.198.668s.093.66.066.734",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagVgb = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagVgb_default = SvgFlagVgb;

export { FlagVgb_default as default };
